<script>
    import Image from '/srv/web/wyvr/html/releases/58819/gen/client/wyvr/Image.svelte?1733898724633';

    export let brand;
</script>

{#if brand}
    <a class="brand-logo" href={brand.url}>
        <Image src={brand.avatar} alt={brand.name} width={140} quality={90} />
    </a>
{/if}
